import { Skeleton } from '@/components/ui/app-skeleton';

export function MarketHeaderSkeleton(): React.ReactNode {
  return (
    <div className="flex items-center gap-3" data-testid="market-header-skeleton">
      <Skeleton className="size-16 shrink-0 rounded-card sm:size-24" />
      <div className="flex min-w-0 flex-1 flex-col gap-2">
        <Skeleton className="h-7 w-3/4" />
        <Skeleton className="h-5 w-48" />
      </div>
    </div>
  );
}
